export enum EPermissionAction {
  READ = 'read',
  CREATE = 'create',
  UPDATE = 'update',
  DELETE = 'delete',
}

export enum EPermissionResource {
  // Dashboard & Analytics
  DASHBOARD = 'dashboard',
  TOTAL_USERS = 'total_users',
  TOTAL_CARD_BALANCE = 'total_card_balance',
  TOTAL_ISSUED_CARDS = 'total_issued_cards',
  TOTAL_ACTIVE_CARDS = 'total_active_cards',
  TOTAL_TRANSACTIONS = 'total_transactions',
  TOTAL_VOLUME = 'total_volume',
  TOTAL_CLIENTS_WALLET_BALANCE = 'total_clients_wallet_balance',
  REFERRAL_COUNT = 'referral_count',

  // New Dashboard Resources
  DEPOSIT_TRANSACTIONS = 'deposit_transactions',
  INTERNAL_SEND_TRANSACTIONS = 'internal_send_transactions',
  CRYPTO_TRANSFERS_WITHDRAWALS = 'crypto_transfers_withdrawals',
  CARD_ISSUE_ATTEMPTS = 'card_issue_attempts',
  CARD_TOP_UP_TRANSACTIONS = 'card_top_up_transactions',
  SWAP_TRANSACTIONS = 'swap_transactions',

  // Transaction Management
  TRANSACTIONS_PAGE = 'transactions_page',
  SEARCH_BUTTON_TRANSACTIONS = 'search_button_transactions',
  FILTER_TRANSACTIONS = 'filter_transactions',
  TRANSACTION_INNER_PAGE = 'transaction_inner_page',

  // Client Management
  CLIENTS_LIST = 'clients_list',
  SEARCH_BUTTON = 'search_button',
  FILTER = 'filter',
  CLIENT_PROFILE = 'client_profile',
  BLOCK_CTA = 'block_cta',
  KYC_CTA = 'kyc_cta',
  INFO = 'info',
  TRANSACTIONS = 'transactions',
  REFERRALS = 'referrals',
  LOGS = 'logs',
  CARDS = 'cards',
  WALLETS = 'wallets',
  CLIENT_BALANCE_EDIT = 'client_balance_edit',

  // Support Management
  SUPPORT_CHATS = 'support_chats',
  LEAVE_CHAT_CTA = 'leave_chat_cta',
  SEND_CTA = 'send_cta',
  SUPPORT_TICKETS = 'support_tickets',
  CREATE_SUPPORT_TICKET_CTA = 'create_support_ticket_cta',
  FILTER_BUTTON_SUPPORT = 'filter_button_support',
  SEARCH_BUTTON_SUPPORT = 'search_button_support',
  FILTER_BY_ASSIGNED_ADMIN = 'filter_by_assigned_admin',
  GET_ALL_TICKETS = 'get_all_tickets',
  GET_BY_TICKET_ID = 'get_by_ticket_id',
  GET_ALL_BY_CLIENT_ID = 'get_all_by_client_id',
  TICKET_INNER_MENU = 'ticket_inner_menu',

  // Admin Management
  TOKENS_INFO = 'tokens_info',
  ADMINS = 'admins',
  CREATE_ADMIN = 'create_admin',
  FILTER_ADMINS = 'filter_admins',
  ASSIGN_ROLE = 'assign_role',
  ACTIVE_INACTIVE_CTA = 'active_inactive_cta',
  PENDING_VERIFICATION = 'pending_verification',
  CONFIRM_CANCEL_CTA = 'confirm_cancel_cta',
  PERMISSION_MANAGEMENT = 'permission_management',
  PASSWORD = 'admin_password',
  ADMIN_LOGS = 'admin_logs',

  // Action Permissions
  APPROVE_CTA = 'approve_cta',
  REJECT_CTA = 'reject_cta',
  WALLET_ADDRESS_INPUT = 'wallet_address_input',

  // Settlement & Solvency
  SOLVENCY = 'solvency',
  ORDER_QUEUE = 'order_queue',

  // Communication
  PUBLIC_NOTIFICATIONS = 'public_notifications',

  // Fees Management
  FEES = 'fees',
}

export interface IPermission {
  resource: string;
  actions: string[];
}

export interface IResource {
  name: string;
  description: string;
  category: string;
  permissions: IPermission;
}

export interface IRole {
  id: string;
  name: string;
  description: string;
  permissions: IPermission[];
}

export interface IAdminPermissions {
  permissions: IPermission[];
}

export type IUpdateRolePermissions = Record<
  string,
  { read: boolean; create: boolean; update: boolean; delete: boolean }
>;

export interface IPermissionCheck {
  hasPermission: boolean;
}

export interface IAccessibleResources {
  resources: string[];
}
